import { ofetch } from 'ofetch';
import { getOrCreateDeviceToken } from '../utils/device-token';

export default defineNuxtPlugin(() => {
  const { APP_PREFIX } = useRuntimeConfig().public;
  globalThis.$fetch = ofetch.create({
    onRequest({ options }) {
      const headers = new Headers(options.headers as HeadersInit);
      headers.set('X-Snapr-Prefix', APP_PREFIX as string);
      const deviceToken = getOrCreateDeviceToken();
      if (deviceToken) {
        headers.set('X-Device-Token', deviceToken);
      }
      options.headers = headers;
    },
  });
});
